import { config } from "../constants/constant";
import axiosInstance from "../constants/globalaxiosinterceptor";
export const adminAPI = config.apiUrl + "/api/DeploymentRequest";

let deploymentRequestsConfig = {
    headers: {
        'Content-Type': 'application/json',
    },
    postHeaders: {
        'Content-Type': 'multipart/form-data'
      },
}

export async function SaveDraftESFMRequest(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_DRAFTREQUEST;
    return await axiosInstance.post(adminAPI + '/savedraftrequest', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function SubmitESFMRequest(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_SUBMITREQUEST;
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    return await axiosInstance.post(adminAPI + '/submitrequest', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetESFMRequestsList() {
    return await axiosInstance.get(adminAPI + '/allesfmrequests',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
};

export async function GetSBPRequestsList() {
    return await axiosInstance.get(adminAPI + '/allsbprequests',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetRequestDetailsById(id) {
    deploymentRequestsConfig.headers.requestId = id;
    return await axiosInstance.get(adminAPI + '/requestDetailsById',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function ReviewESFMRequest(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_REVIEWREQUESTESFM;
    return await axiosInstance.post(adminAPI + '/reviewesfmrequest', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });  
}

export async function ApproveESFMRequest(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_APPROVEREQUESTESFM;
    return await axiosInstance.post(adminAPI + '/approveesfmrequest', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetAllHistories(requestId){
    deploymentRequestsConfig.headers.requestId = requestId;
    return await axiosInstance.get(adminAPI+'/requestHistory', {headers:deploymentRequestsConfig.headers} ).catch((response) =>{
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetAllRemarks(requestId){
    deploymentRequestsConfig.headers.requestId = requestId;
    return await axiosInstance.get(adminAPI+'/requestRemarks', {headers:deploymentRequestsConfig.headers} ).catch((response) =>{
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function DeleteDeploymentRequest(requestId){
    deploymentRequestsConfig.headers.requestId = requestId;
    return await axiosInstance.delete(adminAPI+'/deleteRequest', {headers:deploymentRequestsConfig.headers} ).catch((response) =>{
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function DownloadUploadedDocument(documentName, documentPath) {
    try {
        deploymentRequestsConfig.headers.documentName = documentName;
        deploymentRequestsConfig.headers.documentPath = documentPath;

        const response = await axiosInstance.get(adminAPI + '/downloaddocument', {
            headers: deploymentRequestsConfig.headers,
            responseType: 'arraybuffer',
        });
        if (response.status === 200) {
            return response;
        } else {
            return { success: false, message: 'Failed to download document. Status: ' + response.status };
        }
    } catch (error) {
        return { success: false, message: error.message || 'An error occurred while downloading the document.' };
    }
}

export async function AddRemarkDetails(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    deploymentRequestsConfig.headers.email = userInfo.email;
    return await axiosInstance.post(adminAPI + '/addremarkdetails', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function PostRequestOnDeploymentRoster(requestData) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_POSTREQUESTONDR;
    return await axiosInstance.post(adminAPI + '/postrequestondeploymentroster', requestData, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetDeployeeDetailsByEmail(email) {
    deploymentRequestsConfig.headers.deployeeEmailId = email;
    return await axiosInstance.get(adminAPI+'/deployeeDetailsByEmail', {headers:deploymentRequestsConfig.headers} ).catch((response) =>{
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function PostDeployeeUserDetails(deployeeUser) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_POSTREQUESTONDR;
    return await axiosInstance.post(adminAPI + '/postdeployeeinformation', deployeeUser, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function UpdateCCUsersDetails(data) {
    return await axiosInstance.post(adminAPI + '/updateCcUsersEmailid', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function UpdateWBSAndCieling(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_PROVIDEWBS;
    return await axiosInstance.post(adminAPI + '/updateWbsAndCieling', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetAllExpensesPositions(id) {
    deploymentRequestsConfig.headers.requestId = id;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_DRAFTEXPENSES;
    return await axiosInstance.get(adminAPI + '/expensePositionsById',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetAllExpensesWbs(id) {
    deploymentRequestsConfig.headers.requestId = id;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_DRAFTEXPENSES;
    return await axiosInstance.get(adminAPI + '/expensesWbsById',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetAllExpensesType() {
    return await axiosInstance.get(adminAPI + '/expenseType',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function saveExpenseRecord(expenseData) {
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_DRAFTEXPENSES;
    return await axiosInstance.post(adminAPI + '/draftexpenses', expenseData, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function AllExpensessById(id) {
    deploymentRequestsConfig.headers.requestId = id;
    return await axiosInstance.get(adminAPI + '/allexpenses',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function deleteExpenseRecord(fundingId) {
    deploymentRequestsConfig.headers.deploymentRequestFundingId = fundingId;
    return await axiosInstance.delete(adminAPI + '/deleteexpense',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function submitExpenseRecord(expenseData) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_SUBMITEXPENSES;
    return await axiosInstance.post(adminAPI + '/submitexpenses', expenseData, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function approveExpenseRecord(expenseData) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_APPROVEEXPENSES;
    return await axiosInstance.post(adminAPI + '/approveexpenses', expenseData, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function revertExpensesRecord(expenseData) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    return await axiosInstance.post(adminAPI + '/revertexpenses', expenseData, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function submitFinalReport(reportData) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    return await axiosInstance.post(adminAPI + '/submitreport', reportData, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function updatePositionActualFromToDates(positionData) {
    return await axiosInstance.post(adminAPI + '/updatepositionactualfromtodates', positionData, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function deleteCeilingRecord(wbsDetailId, deploymentRequestId) {
    deploymentRequestsConfig.headers.wbsDetailId = wbsDetailId;
    deploymentRequestsConfig.headers.deploymentRequestId = deploymentRequestId;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_PROVIDEWBS;
    return await axiosInstance.delete(adminAPI + '/deleteceilingrecord',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function SaveDraftSBPRequest(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_DRAFTREQUEST;
    return await axiosInstance.post(adminAPI + '/savedraftsbprequest', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function SubmitRequestToComHod(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_SUBMITREQUEST;
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    return await axiosInstance.post(adminAPI + '/submitrequesttocomhod', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function GetSbpRequestDetailsById(id) {
    deploymentRequestsConfig.headers.requestId = id;
    return await axiosInstance.get(adminAPI + '/sbpRequestDetailsById',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function ComHodApprovalRequest(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_COMAPPROVER;
    return await axiosInstance.post(adminAPI + '/comhodapprovalsbprequest', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function ApproveSBPRequest(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_APPROVEREQUESTSBP;
    return await axiosInstance.post(adminAPI + '/approvesbprequest', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function HandleSendToSbpPartners(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.headers.userName = userInfo.userName;
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_SENDTOSBPAGENCIES;
    return await axiosInstance.post(adminAPI + '/sendtosbppartners', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function UpdateSbpPartnersDetais(data) {
    return await axiosInstance.put(adminAPI + '/updatesbppartners', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function UploadCandidatesCv(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_UPLOADCVS;
    return await axiosInstance.post(adminAPI + '/uploadcandidatecvs', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function GetUploadedCandidatesCvs(id) {
    deploymentRequestsConfig.headers.requestId = id;
    return await axiosInstance.get(adminAPI + '/uploadedCandidatesCvForSbpRequestById',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function SelectCandidateRecord(data) {
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_SELECTCANDIDATE;
    return await axiosInstance.post(adminAPI + '/postSelectCandidateRecord', data,{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });  
}

export async function GetSupportedSbpPartners(id) {
    deploymentRequestsConfig.headers.requestId = id;
    return await axiosInstance.get(adminAPI + '/supportedSbpPartnersByRequestId',{headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function CandidateSelectionMailNotification(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_SELECTCANDIDATE;
    return await axiosInstance.post(adminAPI + '/candidateselectionnotification', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function RLADocumentUpload(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_RLACOORDINATOR;
    return await axiosInstance.post(adminAPI + '/rladocumentupload', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function RLADocumentApproval(data) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    deploymentRequestsConfig.postHeaders.userName = userInfo.userName;
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_SIGNRLAAGREEMENT;
    return await axiosInstance.post(adminAPI + '/rladocumentapproval', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function UploadOnboardingDocuments(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_APPROVEREQUESTSBP;
    return await axiosInstance.post(adminAPI + '/uploadonboardingdocuments', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function NotifyRequestersRegardingOnboardingDocs(data) {
    return await axiosInstance.post(adminAPI + '/notifyRequestersRegardingOnboardingDocs', data,{headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function UpdateApprovedDeploymentsDates(data) {
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_APPROVEREQUESTSBP;
    return await axiosInstance.post(adminAPI + '/updateSbpDeploymentDates', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function SendCheckinSurveyToSelectedCandidate(data) {
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_SENDCHECKINSURVEY;
    return await axiosInstance.post(adminAPI + '/sendcheckinsurvey', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function UpdateCheckinSurvey(data) {
    deploymentRequestsConfig.headers.roleName = process.env.REACT_APP_ROLENAME_SENDCHECKINSURVEY;
    return await axiosInstance.post(adminAPI + '/updatecheckinsurvey', data, {headers:deploymentRequestsConfig.headers}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function SendPerformanceEvaluation(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_SENDPERFORMANCEEVALUATION;
    return await axiosInstance.post(adminAPI + '/sendperformanceevaluationreport', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function UploadPerDocument(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_SENDPERFORMANCEEVALUATION;
    return await axiosInstance.post(adminAPI + '/uploadperdocument', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    });
}

export async function NotifySbpPartnersForRLAInvoice(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_RLACOORDINATOR;
    return await axiosInstance.post(adminAPI + '/notifysbppartnersforrlaresponse', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function UploadRLAInvoice(data) {
    deploymentRequestsConfig.postHeaders.roleName = process.env.REACT_APP_ROLENAME_RLACOORDINATOR;
    return await axiosInstance.post(adminAPI + '/uploadrlainvoice', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function UploadProofOfPayment(data) {
    return await axiosInstance.post(adminAPI + '/uploadproofofpayment', data, {headers:deploymentRequestsConfig.postHeaders}).catch((response) => {
        if (response.code === 200) {
            return (response.data);
        }
        else {
            return response.message;
        }
    }); 
}

export async function FetchSbpRequestsExcel() {
    const response = await axiosInstance.get(adminAPI + '/exportsbpexcel', {
        headers: deploymentRequestsConfig.headers
    });
    if (response.status === 200 && Array.isArray(response.data)) {
        return response.data; 
    }
    return [];
}